export enum StateKey {
  HasBalance = 'hasBalance',
  RichInbox = 'richinbox',
  IsNativeApp = 'isNativeApp',
  Nonce = 'nonce',
}
